// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Tv-z","heading":"Uv-z","outfitFeedbackSection":"Vv-z"};